var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getProd=='getProduits')?_c('index-produit-component',{attrs:{"motCle":_vm.motCle},on:{"updateMotCle":_vm.updateMotCle}}):_vm._e(),(_vm.getProd=='ProduitDetail')?_c('produit-detail-component'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }